import {
    GET_AREA_START,
    GET_AREA_ERROR,
    GET_AREA_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.areas.currentArea, action = {type: ''}) => {
    switch (action.type) {
        case GET_AREA_START:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case GET_AREA_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case GET_AREA_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
                data: [],
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/areaReducer/getAreaReducer.js